import { useEffect, useState } from 'react';
import { THIRTY_SECONDS } from 'shared/constants';

interface CountdownTimerProps {
  endTime: Date;
  startTime?: Date;
}

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}
interface CalculateTimeLeftProps {
  endTime: Date;
  startTime?: Date;
}

const calculateTimeLeft = ({ startTime, endTime }: CalculateTimeLeftProps) => {
  const now = startTime || new Date(Date.now());

  const difference = endTime.getTime() - now.getTime();
  let timeLeft: TimeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };

  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  return timeLeft;
};

const debugMode = false;
const padNumber = (number: number, targetLength = 2, character = '0') =>
  number.toString().padStart(targetLength, character);

export function CountdownTimer(props: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(() =>
    calculateTimeLeft({ startTime: props.startTime, endTime: props.endTime })
  );

  useEffect(() => {
    if (timeLeft.hours > 0 || timeLeft.minutes > 0 || timeLeft.seconds > 0) {
      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft({ startTime: props.startTime, endTime: props.endTime }));
      }, THIRTY_SECONDS);
      return () => clearInterval(timer);
    }
  }, [timeLeft, props.endTime, props.startTime]);

  return (
    <div>
      {padNumber(timeLeft.hours)}h {padNumber(timeLeft.minutes)}m
      {debugMode ? (
        <div style={{ border: '1px solid black' }}>
          <b>DEBUG</b>
          <br />
          Current Time: {new Date(Date.now()).toString()} <br />
          End Time: {JSON.stringify(props.endTime.toString())} <br />
          Time Left: {JSON.stringify(timeLeft)} <br />
        </div>
      ) : (
        ''
      )}
    </div>
  );
}
